import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { RadioBoxParts } from "../../Parts/form/raioBoxParts";


export const EntryFormView = (props) => {

    const { register, handleSubmit,  formState: { errors } } = useForm({
      defaultValues:props.fromValue})
    
    return (
      <>
      <div className="select_desc al-c">
        お客様情報を入力してください<br/>
        <span className="font-red">[すべて必須]</span>
      </div>
        <form onSubmit={handleSubmit(props.onConfirm)}>
            <div className="mb-10">お名前</div>
            <input type="text" 
                name="name" 
                className="f-text" 
                placeholder="例）協会太郎" 
                {...register('name',{ required:true })}/>
            <span className="form_validation">{errors.name && "エラー：未入力"}</span>

            <div className="mb-10 mt-20">住所</div>
            <input 
                type="text" 
                name="address" 
                className="f-text" 
                placeholder="例）福岡県福岡市博多区山王1丁目10-15"
                {...register('address',{ required:true })}
            />
            <span className="form_validation">{errors.address && "エラー：未入力"}</span>
            
            <div className="mb-10 mt-20">メールアドレス</div>
            <input 
                type="email" 
                name="email" 
                className="f-text" 
                placeholder="例）example@lpgas.ne.jp"
                {...register('email' ,
                  { required:true, pattern:'/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/' })} 
              />
              <span className="form_validation">
                {errors.email?.type === "required" && "エラー：未入力"}
                {errors.email?.type === "pattern" && "エラー：形式が違います"}
              </span>

            <div className="flex-resp flex-center mt-20">
              <div>性別</div>
              <div>
                <div className="f-radio">
                  {
                    ['男性','女性', '選択しない'].map(
                      (sex,i) => {
                          return( 
                          <RadioBoxParts 
                            key={i} 
                            {...{id:`sex${i}`,
                                value:sex,
                                label:sex,
                                name:'sex',
                                register}}></RadioBoxParts>
                          )
                      }
                    )
                  }
                
                </div>
              </div>
            </div>
            <div className="flex-resp flex-center">
              <div>年齢</div>
              <div>
                <div className="f-radio">
                {
                    ['20代','30代', '40代', '50代', '60代以上'].map(
                      (age,i) => {
                          return( 
                          <RadioBoxParts 
                            key={i} 
                            {...{id:`age${i}`,
                                value:age,
                                label:age,
                                name:'age',
                                register}}></RadioBoxParts>
                          )
                      }
                    )
                  }
                </div>
              </div>
            </div>
            <div className="mb-10 mt-20">ご家族の人数</div>
            <input 
              type="text" 
              name="family" 
              className="f-text" 
              placeholder="例）00"
              {...register('family')}  
              />            

            <PrivacyTxt></PrivacyTxt>


            <div className="al-c">
              <div className="f-checkbox">
                <input 
                  type="checkbox" 
                  name="agree" 
                  value="1" 
                  id="privacy"
                  {...register('privacy', { required:true})}
                  /><label htmlFor="privacy">個人情報の取り扱いについて同意する</label>
              </div>
            </div>
            <div className="form_validation al-c">{errors.privacy?.type === "required" && "同意が必要です。"}</div>

            <div className="block1 w-500 mt-30">
              <div className="block1_1"><button className="btn5" type="submit">確認</button></div>
              <div className="block1_2"><a className="btn6" onClick={props.prev}>戻る</a></div>
            </div>
          </form>
          </>
    )
}



const PrivacyTxt = () => {

  return(
    <div className="privacy">
				<div className="inner">
					<div><b>【個人情報の取り扱いについて】</b></div>

					<dl className="dl_privacy">
						<dt>【「LPガス祭」個人情報の取り扱いについて】</dt>
			
						<dd>キャンペーン応募における個人情報は、当会及び販売店からの景品発送、各種ご案内、個人を特定しない集計資料作成に厳重な管理下で使用させていただきます。個人情報をお客様の同意を得ないで業務委託意外の第三者に提供、開示する事はありません（法令により開示を認められた場合を除く。）</dd>
			
						<dt>【(一社)福岡県LPガス協会の個人情報保護方針】</dt>
			
						<dd>
              当一般社団法人福岡県LPガス協会がお預かりしている個人情報は、適切な取り扱いと保護を重大な責務と考え、その責務を果たすため個人情報の保護に関する関係法令等を遵守し、個人情報を正確かつ安全な取扱いに努めます。
              <dl className="dl_privacy_items">
                <dt>個人情報の収集に関する方針</dt>
                <dd>
                個人情報を入手する場合は、その利用目的を特定し、通知・公表又は明示し、収集いたします。
                </dd>
                <dt>個人情報の利用に関する方針</dt>
                <dd>
                入手した個人情報はその利用目的に沿って、本人の同意を得た範囲内で利用いたします。 また、同意を得た利用目的　の範囲以外の第三者への提供・開示は行ないません。
                </dd>
                <dt>個人情報の提供に関する方針</dt>
                <dd>
                入手した個人情報はその利用目的に沿って、外部に委託する場合は、適正に管理・監督をいたします。
                </dd>
                <dt>個人情報の安全な管理に関する方針</dt>
                <dd>
                個人情報の取り扱いについて、安全管理に関する講じ、個人情報に関する適正な維持・管理に努めます。
                </dd>
                <dt>個人情報に関する法令遵守に関する方針</dt>
                <dd>
                個人情報に関する法令等を遵守するとともに、定期的に組織体制を確認し、必要に応じて見直しを行なうことといたします。
                </dd>
              </dl>
            </dd>
            </dl>
            <p>当協会が所有している個人情報について、開示、訂正、追加、削除、利用停止等のご希望がある場合は、次の連絡先までお知らせください。</p>
						<p>
            当協会が所有している個人情報について、開示、訂正、追加、削除、利用停止等のご希望がある場合は、次の連絡先までお知らせください。
            (一社)福岡県LPガス協会	福岡市博多区山王1-10-15
            TEL.092-476-3838
            </p>
				</div>
			</div>
  )
}